module.exports = __webpack_public_path__ + "static/Scheme-e3kit@2x-6061c5d77b8ea35305757a9c8b5eeaba.png";